module.exports = __webpack_public_path__ + "img/govt-school.ae8943e4.svg";